import { c as _c } from "react/compiler-runtime";
import { Box, Image, Separator, VStack } from '@chakra-ui/react';
import { ArticleFeatured } from '@src/components/sco/Education/HomeLanding/Addons/ArticleFeatured';
import { ContentTrackListFeatured } from '@src/components/sco/Education/HomeLanding/Addons/ContentTrackListFeatured';
import { VideoFeatured } from '@src/components/sco/Education/HomeLanding/Addons/VideoFeatured';
import { HomeListCard } from '@src/components/sco/Education/HomeLanding/HomeListCard';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import React from 'react';
import Marquee from 'react-fast-marquee';
import { LuBook, LuGraduationCap, LuPodcast, LuVideo, LuVideotape } from 'react-icons/lu';
export const HomeList = () => {
  const $ = _c(5);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Separator borderColor="colorPalette.border/30" width="full" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== getBreakpointValue) {
    t1 = pageSections.map((section, index) => <HomeListCard key={index} addon={section.addon} cta={section.cta} description={section.description} direction={getBreakpointValue(["column", index % 2 ? "row-reverse" : "row"])} featuredImage={section.featuredImage} headline={section.headline} href={section.href} icon={section.icon} sideAddon={section.sideAddon} style={section.style} title={section.title} />);
    $[1] = getBreakpointValue;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <VStack gap={0} separator={t0} width="full">{t1}</VStack>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
const videoLogos = ['https://media.graphassets.com/yUP3x0tvTMeavk4wvEyx', 'https://media.graphassets.com/p93qggAGQ7uovrXYSsVU', 'https://media.graphassets.com/MUbsPssQTTG9H5QAxi5s', 'https://media.graphassets.com/fORwNAcUTenBGdUqKaUw', 'https://media.graphassets.com/m8oVpCbdR5H5prvEjKo9', 'https://media.graphassets.com/Jwc37CvSgaOI3PuaKRLA', 'https://media.graphassets.com/Qpex39hkTsKcoayRGesl', 'https://media.graphassets.com/ipKPO04RZ2TA5SKoRF5w', 'https://media.graphassets.com/xSs0oFhBS9i2Tcu7u9Uh', 'https://media.graphassets.com/teEcLdMQ75eTwo7sWPnw'];
const founderLogos = ['https://media.graphassets.com/SbfquUGSlynDWtIqZIB4', 'https://media.graphassets.com/H7Y3uU7MRHqYsi6tRPD6', 'https://media.graphassets.com/P3NQy8NStibdh7UARB4A', 'https://media.graphassets.com/XwkHzViRQlqjC4wpGRRi', 'https://media.graphassets.com/Imp2gp9TnSswix5hfACZ', 'https://media.graphassets.com/Drh37FSPSMq54gsdct2c', 'https://media.graphassets.com/4jWT5WTp20scH6xCPwIk', 'https://media.graphassets.com/yqkxQamQ96llGODSQq3A', 'https://media.graphassets.com/XDbIbfppSWey38e9ZvbH', 'https://media.graphassets.com/8JiFS0QPC7R3PUirD1MQ', 'https://media.graphassets.com/GEuMCyRNKJ3tNmMmVygX', 'https://media.graphassets.com/HXLmTRoQnKdHxAq8M4db', 'https://media.graphassets.com/nAASnyy3Tee9FFhzfd82', 'https://media.graphassets.com/XoiLvrA4R5yrsfj0fylE', 'https://media.graphassets.com/SLJlwz6xQPKJ2trkrXRY', 'https://media.graphassets.com/xZ01WKkrQOGiQzxJzKCb', 'https://media.graphassets.com/SxQP5oN4TCmXat5Z8x2a', 'https://media.graphassets.com/dLkMnuQQdq4FvdCWDcd3', 'https://media.graphassets.com/0B2XmRPNRtq31X8POGIG', 'https://media.graphassets.com/nHGvHbApTnuOie9n5DYq', 'https://media.graphassets.com/2hOdC9nmSgmjvjsRkWTh', 'https://media.graphassets.com/9YuG0xAJTXqZLnFXi0uz'];
const pageSections = [{
  title: 'Courses',
  titleTag: 'h1',
  headline: 'Get a PhD in Startups',
  description: 'Ridiculously comprehensive courses on every aspect of starting a company. From finding investors to acquiring customers to validating your idea. All at your fingertips.',
  href: '/courses',
  icon: LuGraduationCap,
  featuredImage: '/assets/graphics/courses.png',
  style: {
    filter: 'drop-shadow(0px 10px 8px rgba(0, 0, 0, 0.35))'
  },
  cta: 'Explore All Courses',
  addon: <ContentTrackListFeatured />
}, {
  title: 'Videos',
  headline: 'Learn from the Experts Behind the Biggest Startups',
  description: `Comprehensive, guided video series on how to validate your idea, acquire your first customers and secure funding.`,
  href: '/videos',
  icon: LuVideo,
  featuredImage: '/assets/graphics/videos.png',
  style: {
    filter: 'drop-shadow(-5px 0px 5px rgba(0, 0, 0, 0.35))'
  },
  cta: 'Streaming now',
  addon: <VStack align={'flex-start'} gap={8}>
        <Box marginY={12} width={'full'}>
          <Marquee autoFill={true} gradient={true} gradientColor={'colorPalette.bg'}>
            {videoLogos.map((imageUrl, index) => <Image key={index} filter={{
          _light: 'invert(1)',
          _dark: 'invert(0)'
        }} height={'26px'} src={imageUrl} style={{
          marginRight: '80px'
        }} // Add spacing between images
        width={'auto'} />)}
          </Marquee>
        </Box>

        <VideoFeatured />
      </VStack>
}, {
  title: 'Podcast',
  headline: `The No-BS Version of Startup Life`,
  description: `The Startup Therapy Podcast dives deep into the problems startup Founders face every day to unpack what's really at stake and how to actually solve them.`,
  href: '/podcast',
  icon: LuPodcast,
  //featuredImage: 'https://media.graphassets.com/resize=fit:max,width:1000/z3g49bTS56qEgDMcmfgD',
  cta: 'All Episodes',
  sideAddon: <Image flex={1} height={'full'} objectFit={'contain'} src={'/assets/backgrounds/podcast-hero.png'} width={'full'} style={{
    filter: 'drop-shadow(0px 5px 8px rgba(0, 0, 0, 0.25))'
  }} />
}, {
  title: 'Articles',
  headline: 'Get Expert Advice',
  description: `Hand-curated advice from startup Founders on every aspect of starting a company.`,
  href: '/articles',
  icon: LuBook,
  featuredImage: '/assets/graphics/articles.png',
  style: {
    filter: 'drop-shadow(0px 10px 8px rgba(0, 0, 0, 0.35))'
  },
  cta: 'Explore Articles',
  addon: <ArticleFeatured articleType={'ExpertAdvice'} carouselTitle={'Featured Articles'} />
}, {
  title: 'Founder Interviews',
  headline: 'Origin Stories of Legendary Founders',
  description: `Personal, candid interviews with the most world-changing Founders of all time.`,
  href: '/founder-interviews',
  icon: LuVideotape,
  featuredImage: '/assets/graphics/interviews.png',
  cta: 'Explore Interviews',
  addon: <VStack align={'flex-start'} gap={8}>
        <Box marginY={12} width={'full'}>
          <Marquee autoFill={true} gradient={true} gradientColor={'colorPalette.bg'}>
            {founderLogos.map((imageUrl, index) => <Image key={index} filter={{
          _light: 'invert(1)',
          _dark: 'invert(0)'
        }} height={'26px'} src={imageUrl} style={{
          marginRight: '80px'
        }} // Add spacing between images
        width={'auto'} />)}
          </Marquee>
        </Box>
        <ArticleFeatured articleType={'FounderStory'} carouselTitle={'Featured Interviews'} />
      </VStack>
}];